module.exports = __webpack_public_path__ + "img/logo_wcaworld1.23969e4d.png";